import produce from 'immer';
import { HISTORY_DATA_MANAGEMENT_ACTIONS } from './actions';

const initialState = {
  records: [],
  loading: false,
  type: '',
};

const HistoryManagement = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = type;
      });
    case HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA_SUCCESS:
      return produce(state, (draft) => {
        draft.records = payload;
        draft.loading = false;
        draft.type = type;
      });
    case HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = type;
      });
    default:
      return state;
  }
};

export default HistoryManagement;
